module.exports = __webpack_public_path__ + "static/img/317fede5-563d-4f74-8017-90367c99e3c2.1d370d55.png";